<template>
    <div class="service-image-modal">
        <div class="image-upload-overlay" @click="cancelProductImageUpload"></div>
        <div class="image-upload-overlay-content image-upload-wrapper">
            <input class="product-image-input-file" type="file" ref="productImageInputFile" accept="image/*"
                @change="productImageChange" />

            <div class="service-image-modal-heading">
                <h4>{{ (editServiceObj.image || editServiceObj.image_preview) ? $t("services.changeImg") :
                    $t("services.uploadImage") }}</h4>
            </div>

            <div class="service-image-modal-container">
                <div class="service-upload-image">
                    <input type="text" class="selectInput" disabled
                        :placeholder="productImageUpload.fileName || 'No file selected'" />
                    <div class="input-group-append">
                        <button @click="openFileBrowser" type="button" class="browse primary-btn extra-small">
                            Browse...
                        </button>
                    </div>
                </div>

                <div class="cropper-wrapper" v-if="productImageUpload.preview">
                    <cropper ref="cropper" class="cropper" :src="productImageUpload.preview"
                        :stencil-props="{ aspectRatio: 1 / 1 }" />
                </div>

                <div v-if="productImageUpload.preview" class="modal-btns-actions">
                    <button @click.prevent="zoom(0.2)"><i class="fa fa-search-plus"></i></button>
                    <button @click.prevent="zoom(-0.2)"><i class="fa fa-search-minus"></i></button>
                    <button @click.prevent="rotate(90)"><i class="fa fa-repeat"></i></button>
                    <button @click.prevent="rotate(-90)"><i class="fa fa-undo"></i></button>
                    <button @click.prevent="flipX"><i class="fa fa-arrows-h"></i></button>
                    <button @click.prevent="flipY"><i class="fa fa-arrows-v"></i></button>
                    <button @click.prevent="reset"><i class="fa fa-refresh"></i></button>
                </div>

                <div class="service-modal-btns-container">
                    <button @click="saveProductImageUpload" :disabled="!productImageUpload.preview"
                        class="primary-btn extra-small">
                        Save
                    </button>
                    <button @click="cancelProductImageUpload" class="secondary-btn small">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import api from "../../services/apiEndpoints.js";
import auth from "./../../services/auth.js";
import messages from "./../../services/messages.js";


export default {
    props: ["imageField", "editServiceObj"],
    emits: ["close-modal"],
    data: function () {
        return {
            productImageUpload: {
                show: false,
                preview: null,
                fileName: null,
                file: null,
                croppedImage: null,
            },
            disableAction: {
                service: false,
                category: false,
            },
            user: null,
        };
    },

    mounted: function () {
        this.user = auth.state.user;
    },
    beforeUnmount() {},
    computed: {},
    methods: {
        openFileBrowser() {
            this.$refs.productImageInputFile.click();
        },

        // productImageChange(e) {
        //     const file = e.target.files[0];
        //     if (!file) return;

        //     this.productImageUpload.fileName = file.name;
        //     this.productImageUpload.file = file;

        //     // Use ObjectURL for instant preview performance
        //     this.productImageUpload.preview = URL.createObjectURL(file);
        // },
        productImageChange: function (e) {
            let file = e.target.files[0];
            this.productImageUpload.file = file;
            this.productImageUpload.fileName = file.name;

            //check how big is the image
            if (file != "") {
                const fileSize = file.size;
                const fileMb = fileSize / 1024 ** 2;

                if (fileMb >= 2) {
                    messages.errorMessage(messages.ERROR_MESSAGES.IMAGE_TO_BIG);

                    return;
                }
            }

            let self = this;
            var reader = new FileReader();
            reader.onload = function (e) {
                // get loaded data and render thumbnail.
                // Resize the image
                var image = new Image();
                image.onload = () => {
                    var canvas = document.createElement("canvas"),
                        max_size = 1000,
                        width = image.width,
                        height = image.height;
                    if (width > height) {
                        if (width > max_size) {
                            height *= max_size / width;
                            width = max_size;
                        }
                    } else {
                        if (height > max_size) {
                            width *= max_size / height;
                            height = max_size;
                        }
                    }
                    canvas.width = width;
                    canvas.height = height;
                    var ctx = canvas.getContext("2d");
                    ctx.drawImage(image, 0, 0, width, height);
                    let dataUrl = canvas.toDataURL();
                    self.productImageUpload.preview = dataUrl;
                };
                image.src = e.target.result;
            };
            // read the image file as a data URL.
            reader.readAsDataURL(file);
        },

        saveProductImageUpload() {
            const { canvas } = this.$refs.cropper.getResult();
            if (canvas) {
                const imageData = canvas.toDataURL("image/jpeg");

                // Dynamic emission based on imageField prop
                const payload = {};
                const fieldSuffix = this.imageField === 'image' ? '' : this.imageField.replace('image', '');

                payload[`image${fieldSuffix}_content`] = imageData;
                payload[`image${fieldSuffix}_name`] = this.productImageUpload.fileName;

                this.$emit("preview-image", payload);
                this.cancelProductImageUpload();
            }
        },

        cancelProductImageUpload() {
            // Clean up ObjectURL to prevent memory leaks
            if (this.productImageUpload.preview) {
                URL.revokeObjectURL(this.productImageUpload.preview);
            }

            this.productImageUpload = {
                show: false,
                preview: null,
                fileName: null,
                file: null
            };

            // Reset the file input so the same file can be uploaded again
            if (this.$refs.productImageInputFile) this.$refs.productImageInputFile.value = '';

            this.$emit("close-modal");
        },
        // Actions
        zoom(val) { 
            this.$refs.cropper.zoom(1 + val); 
        },
        rotate(deg) { 
            this.$refs.cropper.rotate(deg); 
        },
        flipX() { 
            this.$refs.cropper.flip(true, false); 
        },
        flipY() { 
            this.$refs.cropper.flip(false, true);
         },
        reset() { 
            this.$refs.cropper.reset();
         },
        getProductImage(image_url) {
            return api.API_ENDPOINT + "/uploads/images/services/" + this.user.id + "/" + image_url;
        },
    },
    components: { Cropper },
};
</script>
